<app-nav></app-nav>
<!-- only nav content -->
